import React, { useCallback, useContext, useState } from "react";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import IconButton from "@mui/material/IconButton";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import Stack from "@mui/material/Stack";
import TextField from "@mui/material/TextField";
import type { SxProps, Theme } from "@mui/material/styles";
import ChevronLeft from "@mui/icons-material/ChevronLeft";
import ChevronRight from "@mui/icons-material/ChevronRight";
import { DateCalendar } from "@mui/x-date-pickers/DateCalendar";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import checkedFile from "assets/CheckFilled.svg";
import {
  ClientRescheduleDropdown,
  default_Dropdown,
} from "./staticRescheduleData";
import Spinner from "components/Spinner/spinner";
import moment from "moment";
import { formatTime } from "./clientReschedule.helper";
import { myContext } from "hooks/useContext/useContext";
import dayjs, { Dayjs } from "dayjs";
import { useNavigate } from "react-router-dom";
import { appointments } from "types/calender/appointments";
import { Cancel_Name } from "../CancelAppointments/staticCancelData";

// The built-in DateCalendar header is replaced by the custom month/year header
// rendered above it (mirrors the previous antd Calendar headerRender).
const EmptyCalendarHeader = () => null;

const headerSelectSx: SxProps<Theme> = {
  bgcolor: "primary.light",
  color: "#122f4e",
  fontSize: 15,
  fontWeight: 900,
  "& .MuiOutlinedInput-notchedOutline": { border: "none" },
};

const calendarSx: SxProps<Theme> = {
  width: "100%",
  height: "auto",
  maxHeight: "none",
  "& .MuiDayCalendar-weekDayLabel": { fontWeight: 700 },
  "& .MuiPickersDay-root": { fontSize: 14, fontWeight: 500 },
  "& .MuiPickersDay-root.Mui-selected:not(.Mui-disabled)": {
    bgcolor: "#122f4e",
  },
};

interface Props {
  rcSuggestions: any;
  selectedDate: any;
  earliestEnabledDate: Dayjs;
  clickedIndex: number;
  dropdown: any;
  activeDay: string;
  appointment: appointments;
  path: string;
  textAreaValue: string;
  payload: any;
  flow?: string;
  handleBackButton: () => void;
}

export const ClientRescheduleCalender: React.FC<Props> = ({
  rcSuggestions,
  selectedDate,
  earliestEnabledDate,
  clickedIndex,
  dropdown,
  activeDay,
  appointment,
  path,
  textAreaValue,
  payload,
  flow,
  handleBackButton,
}) => {
  console.log(
    rcSuggestions,
    selectedDate,
    earliestEnabledDate,
    clickedIndex,
    dropdown,
    activeDay,
    appointment,
    path,
    textAreaValue,
    handleBackButton,
    "[reschedule] calender component"
  );

  const { setState } = useContext(myContext);
  const navigate = useNavigate();

  const onPanelChange = (value: Dayjs, mode: string) => {
    if (mode === "month") {
      value = value.startOf("month");
    }
    console.log(value, mode, "[reschedule] value in onPanelChange");
  };

  const handleDateSelect = (value: any) => {
    const objData = rcSuggestions.find(
      (element: any) => element.date === value.format("MM/DD/YYYY")
    );
    setState((prevState: any) => ({
      ...prevState,
      selectedDate: objData,
      clickedIndex: -1,
    }));

    console.log(objData, "[reschedule] data1");
  };

  const disabledDate = (current: Dayjs) => {
    const dateString = current.format("MM/DD/YYYY");
    const dateData = rcSuggestions?.find(
      (item: any) => item.date === dateString
    );
    return !dateData;
  };

  const handleChange = (value: string | string[]) => {
    console.log(`Selected: ${value}`, "[reschedule] selected dropdown");
    setState((prevState: any) => ({ ...prevState, dropdown: value }));
  };

  const handleTimeClick = useCallback(
    (
      index: number,
      startTime: string,
      endtime: string,
      event: React.MouseEvent<HTMLDivElement>
    ) => {
      setState((prevState: any) => ({
        ...prevState,
        clickedIndex: index,
        newStartTime: startTime,
        newEndTime: endtime,
      }));
      console.log(event.currentTarget.textContent, "[reschedule] date value");
      console.log(
        startTime,
        endtime,
        "[reschedule] clicked starttime and endTime"
      );
    },
    [setState]
  );

  const handleTextData = (value: string) => {
    console.log(value, "[reschedule] textArea");
    setState((prevState: any) => ({ ...prevState, textArea: value }));
  };

  console.log(flow, "[rescheduleCalender] flow");

  const handleNextButton = () => {
    navigate("/client-reschedule-confirm",{
      state: {
        appointment: appointment,
        activeDay: activeDay,
        path: path,
        payload: payload,
        flow: flow,
      },
    });
  };

  // antd Calendar used defaultValue (uncontrolled). Until the user picks or
  // navigates, follow the same default (selected date, else earliest enabled
  // date); after that the calendar owns its value.
  const [pickedDate, setCalendarValue] = useState<Dayjs | null>(null);
  const calendarValue: Dayjs =
    pickedDate ??
    (selectedDate?.date === undefined
      ? earliestEnabledDate ?? dayjs()
      : dayjs(selectedDate?.date));

  // antd's headerRender onChange both moved the panel and selected the new
  // date (firing onSelect); preserve that so month/year navigation behaves
  // the same: the same day in the new month becomes the selected date.
  const changeCalendarDate = (next: Dayjs) => {
    if (!next.isSame(calendarValue, "month")) {
      onPanelChange(next, "month");
    }
    setCalendarValue(next);
    handleDateSelect(next);
  };

  const renderCalendarHeader = () => {
    const value = calendarValue;
    console.log(value, "[reschedule] year value");
    const year = value.year();
    const month = value.month();
    const monthsShort = moment.monthsShort(); // Get localized month names using moment

    return (
      <Stack
        direction="row"
        alignItems="center"
        justifyContent="space-between"
        sx={{ p: "10px" }}
      >
        <IconButton
          size="small"
          aria-label="Previous month"
          onClick={() => changeCalendarDate(value.subtract(1, "month"))}
        >
          <ChevronLeft fontSize="small" />
        </IconButton>
        <Stack direction="row" alignItems="center" spacing={1}>
          <Select
            size="small"
            className="dropdown-1"
            value={month}
            onChange={(e) => changeCalendarDate(value.month(Number(e.target.value)))}
            inputProps={{ "aria-label": "Month" }}
            sx={headerSelectSx}
          >
            {monthsShort.map((monthName, index) => (
              <MenuItem key={index} value={index}>
                {monthName}
              </MenuItem>
            ))}
          </Select>
          <Select
            size="small"
            className="dropdown-1"
            value={year}
            onChange={(e) =>
              changeCalendarDate(
                dayjs().year(Number(e.target.value)).startOf("year")
              )
            }
            inputProps={{ "aria-label": "Year" }}
            sx={{ ...headerSelectSx, width: 80 } as SxProps<Theme>}
          >
            {Array.from({ length: 20 }, (_, i) => (
              <MenuItem key={i} value={year - 10 + i}>
                {year - 10 + i}
              </MenuItem>
            ))}
          </Select>
        </Stack>
        <IconButton
          size="small"
          aria-label="Next month"
          onClick={() => changeCalendarDate(value.add(1, "month"))}
        >
          <ChevronRight fontSize="small" />
        </IconButton>
      </Stack>
    );
  };

  const ButtonDisable = clickedIndex === -1 || dropdown === default_Dropdown;
  return (
    <>
      {rcSuggestions ? (
        <div className="reschedule-body">
          <div className="rescheduling-calender-left">
            <div className="reschedule-calender-style">
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                {renderCalendarHeader()}
                <DateCalendar
                  value={calendarValue}
                  onChange={(value: Dayjs | null) => {
                    if (value) {
                      setCalendarValue(value);
                      handleDateSelect(value);
                    }
                  }}
                  shouldDisableDate={disabledDate}
                  slots={{ calendarHeader: EmptyCalendarHeader }}
                  sx={calendarSx}
                />
              </LocalizationProvider>
            </div>
          </div>
          <div className="rescheduling-calender-right">
            <div className="rescheduling-calender-right-top">
              {selectedDate ? (
                <>
                  <span className="right-heading">Available Times</span>
                  <Box
                    className="right-time"
                    sx={{ display: "flex", flexWrap: "wrap" }}
                  >
                    {selectedDate?.times?.map((item: any, index: any) => {
                      const timeClass =
                        clickedIndex !== index && clickedIndex !== -1
                          ? "clicked-time"
                          : "";
                      const renderImage = clickedIndex === index;
                      const showTime = formatTime(
                        item.startTime,
                        selectedDate?.clientTimezone
                      );

                      const startTime = item.startTime;
                      const endTime = item.endTime;
                      return (
                        <Box
                          sx={{ flex: "0 0 20.8333%", maxWidth: "20.8333%" }}
                          className={`right-time-inner ${timeClass}`}
                          key={index}
                          onClick={(event) =>
                            handleTimeClick(index, startTime, endTime, event)
                          }
                        >
                          {renderImage && (
                            <img
                              src={checkedFile}
                              alt="checked"
                              className="checkedImg"
                            />
                          )}
                          <span className="inner-timming">{showTime}</span>
                        </Box>
                      );
                    })}
                  </Box>

                  <div className="right-dropdown">
                    <Select
                      size="small"
                      onChange={(e) => handleChange(e.target.value as string)}
                      sx={{ width: "100%" }}
                      value={dropdown}
                      // id on the clickable element (keeps GTM/e2e targeting)
                      SelectDisplayProps={{ id: "Reschedule-Reason" }}
                    >
                      {/* Placeholder: dropdown starts as the default_Dropdown prompt text */}
                      <MenuItem
                        value={default_Dropdown}
                        disabled
                        sx={{ display: "none" }}
                      >
                        {default_Dropdown}
                      </MenuItem>
                      {ClientRescheduleDropdown.map((option) => (
                        <MenuItem key={option.value} value={option.value}>
                          {option.label}
                        </MenuItem>
                      ))}
                    </Select>
                  </div>
                  <div
                    className={dropdown === 5 ? "displayShow" : "displayNone"}
                  >
                    <TextField
                      multiline
                      fullWidth
                      rows={4}
                      placeholder="Add note (Optional)"
                      onChange={(e) => handleTextData(e.target.value)}
                      value={textAreaValue}
                    />
                  </div>
                </>
              ) : (
                <span className="right-inactive-days">
                  Please click on the active days to view the Available Times
                </span>
              )}
            </div>
            <div className="right-button">
              <Button
                id="Reschedule-abandonment"
                variant="outlined"
                size="large"
                onClick={() => handleBackButton()}
                className="button-1"
              >
                {flow === Cancel_Name ? "Cancel Instead" : "Back"}
              </Button>
              <Button
                id="Reschedule-selection"
                variant="contained"
                size="large"
                className="button-next button-1"
                disabled={ButtonDisable}
                onClick={handleNextButton}
              >
                Next
              </Button>
            </div>
          </div>
        </div>
      ) : (
        <>
          <Spinner />
          <span className="client-reschedule-spinner-sub-heading">
            {" "}
            Please wait for a few seconds. We are fetching new dates and timings
            for you.
          </span>
        </>
      )}
    </>
  );
};

export default ClientRescheduleCalender;
